module.exports = __webpack_public_path__ + "media/application/images/bg-finger-print-8ee1e5223650f4f15f41852cb5955e3e.png";